/**
 * AMBA pitch brand: "ScamDefense" wordmark for the Association of Military
 * Banks of America build. Navy + gold identity (distinct from the DCUC
 * navy/red OnGuard pitch).
 */

export const AMBA_EMAIL = 'info@scamdefense.org'

/** "ScamDefense" wordmark. `onDark` for navy backgrounds. */
export function AmbaMark({
  onDark = true,
  className = '',
}: {
  onDark?: boolean
  className?: string
}) {
  return (
    <span className={`inline-flex items-baseline font-bold tracking-tight ${className}`}>
      <span className={onDark ? 'text-white' : 'text-[#253a3f]'}>Scam</span>
      <span className={onDark ? 'text-[#d9bd76]' : 'text-[#a9863b]'}>Defense</span>
    </span>
  )
}
